// Mozilla/5.0 ZoomWebKit/537.36 (KHTML, like Gecko) ZoomApps/1.0
import { zoomLinkValidator } from '@lib/zoom-helpers';
import * as yup from 'yup';

export const ZOOMAPP_CONNECT_COOKIE = 'sa-connect';
export const ZOOMAPP_SESSION_COOKIE = 'sa-session';

export const _isZoomApp = (userAgentString) => userAgentString.match(/zoom/i);

export const isZoomApp = () => {
  if (typeof window !== 'undefined') {
    return _isZoomApp(window.navigator.userAgent);
  }
  return false;
};

export const zoomAppBasePath = process.env.NEXT_PUBLIC_ZM_BASE_PATH;

export const redirectToZoomApp = (router) => {
  if (isZoomApp()) {
    router.push(zoomAppBasePath);
  }
};

export const isMeetingContext = (context = '') => {
  if (context?.match(/^(inMeeting|inWebinar|meeting|webinar)$/i)) {
    return true;
  };
  return false;
};

export const getResourceType = (context = '') => {
  if (context.match(/inMeeting|meeting/i)) {
    return 'meetings';
  }
  if (context.match(/inWebinar|webinar/i)) {
    return 'webinars';
  }
};

export const getErrorMessage = (error) => {
  let errorMessage;
  if (error?.reason) {
    errorMessage = error.reason;
  } else {
    errorMessage = 'Something went wrong. Please try again.';
  }
  return errorMessage;
};

export const signupLink = `${process.env.NEXT_PUBLIC_URL}signup?utm_source=zoomapp&utm_medium=app`;

export const sandboxLink = process.env.NEXT_PUBLIC_SANDBOX_URL;

export const isHostOrCoHost = (role = '') => role.match(/^(host|co-host|coHost)$/i);

export const meetingLinkSchema = yup.object().shape({
  meeting_link: zoomLinkValidator()
});

export const isWindows = (userAgent) => userAgent?.match(/windows/i);
